var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanceTrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 0.500037C13.9706 0.500037 18 4.52948 18 9.50002C18 14.4706 13.9706 18.5 9.00002 18.5C4.02948 18.5 3.73308e-05 14.4706 3.73308e-05 9.50002C-0.014106 4.54357 3.99238 0.51418 8.94878 0.500037C8.96586 0.499988 8.98294 0.499988 9.00002 0.500037Z",
    fill: "#D43939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4203 4.87316L10.7152 4.16797L10.01 4.87316L9.30478 4.16797L8.59959 4.87316L7.8944 4.16797L7.18921 4.87316L6.48402 4.16797L5.77884 4.87316L5.07365 4.16797V10.7497H3.66327V12.1601C3.66327 12.9405 4.29324 13.5705 5.07365 13.5705H10.7152C11.4956 13.5705 12.1255 12.9405 12.1255 12.1601V4.16797L11.4203 4.87316ZM11.1853 12.1601C11.1853 12.4187 10.9737 12.6302 10.7152 12.6302C10.4566 12.6302 10.245 12.4187 10.245 12.1601V10.7497H6.0139V5.57835H11.1853V12.1601Z",
    fill: "#FFE4E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31081 6.51953H6.49005V7.45978H9.31081V6.51953Z",
    fill: "#FFE4E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7209 6.51953H9.78064V7.45978H10.7209V6.51953Z",
    fill: "#FFE4E4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31081 7.92969H6.49005V8.86994H9.31081V7.92969Z",
    fill: "#FFE4E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7209 7.92969H9.78064V8.86994H10.7209V7.92969Z",
    fill: "#FFE4E4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5814,
    cy: 12.4465,
    r: 3.49528,
    fill: "#D43939"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5838 9.6875C10.0579 9.6875 8.8244 10.921 8.8244 12.4469C8.8244 13.9729 10.0579 15.2064 11.5838 15.2064C13.1098 15.2064 14.3433 13.9729 14.3433 12.4469C14.3433 10.921 13.1098 9.6875 11.5838 9.6875ZM12.9636 13.4376L12.5745 13.8267L11.5838 12.836L10.5932 13.8267L10.2041 13.4376L11.1948 12.4469L10.2041 11.4563L10.5932 11.0672L11.5838 12.0579L12.5745 11.0672L12.9636 11.4563L11.9729 12.4469L12.9636 13.4376Z",
    fill: "#FFE4E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanceTrade);
export default __webpack_public_path__ + "static/media/cance_trade.396b67a3cafb24f06a772b9e13eaf01b.svg";
export { ForwardRef as ReactComponent };